<template>
  <div class="footer">
    <p>
      <router-link to="/attributions">Info &amp; Attributions</router-link>
      <router-link to="/contact">Contact me</router-link>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  }
}
</script>

<style scoped>
  p {
    text-align: center;
  }
  /* Style the header links */
  .footer a {
    float: inherit; 
    color: #565656;
    text-align: center;
    padding: 0.5em;
    text-decoration: none;
    padding-bottom: none;
    padding-top: 1.5em;
    font-size: 18px; 
    line-height: 1em;
    /* border-radius: 4px; */
  }

  /* Change the background color on mouse-over */
  .footer a:hover {
    color: black;
    border-bottom: 2px solid black;
  }

  .footer {
    overflow: hidden;
    width: 100%;
    text-align: center;
    align-content: center;
    padding-bottom: 0.5en;
    padding-top: 1.5em;
  }
</style>
